import axios from 'axios';
import { b2bPaymentsApi } from '../b2b/payments';
import { b2cPaymentsApi } from '../b2c/payments';
import { isProd } from '../../utils/environments';
import { apiB2B } from '../axios-client';
import { ADD_CREDIT_CARD, GET_ORANGE_PAY_TOKEN, GET_RSA_PUBLIC_KEY_URL, GET_RSA_PUBLIC_KEY_QA_URL, } from '../../constants/links';
export const paymentsApi = {
    paypalInit: (isB2B) => {
        return isB2B
            ? b2bPaymentsApi.paypalInit().then(({ data }) => {
                if (data.token) {
                    return data.token;
                }
                throw new Error('no token');
            })
            : b2cPaymentsApi.paypalInit().then(({ data }) => {
                if (data.ecToken) {
                    return data.ecToken;
                }
                throw new Error('no token');
            });
    },
    initPayPalV2: () => {
        return b2bPaymentsApi.initPayPalV2().then(({ data }) => {
            if (data.token) {
                return data.token;
            }
            throw new Error('no token');
        });
    },
    paypalSave: ({ orderID, payerID, paymentCard }, isB2B) => {
        return isB2B
            ? b2bPaymentsApi.paypalSave(orderID, paymentCard)
            : b2cPaymentsApi.paypalSave(orderID, payerID);
    },
    savePayPalV2: ({ orderID, paymentCard }) => {
        return b2bPaymentsApi.savePayPalV2(orderID, paymentCard);
    },
    getOrangePayToken: () => {
        return apiB2B.post(GET_ORANGE_PAY_TOKEN);
    },
    addPaymentCard: (paymentCard, recaptcha, deviceid) => {
        return apiB2B
            .post(ADD_CREDIT_CARD, {
            addPaymentCardRequest: {
                paymentCard,
            },
        }, {
            headers: {
                'X-PAA-AUTH': recaptcha,
                deviceid: deviceid || undefined,
            },
        })
            .then(({ data }) => {
            return data;
        });
    },
    // returns null in the event of an API error so that you cannot incorrectly assume it was a string returned as empty
    getRsaPublicKey: () => {
        return axios
            .get(isProd() ? GET_RSA_PUBLIC_KEY_URL : GET_RSA_PUBLIC_KEY_QA_URL)
            .then(({ data }) => data)
            .catch(() => null);
    },
};
